var constants = require('../constants');
var api = require('../../../utils/api');
var commonActions = require('../../common/actions/common');

var Condition = (function() {

    var _requestCondition = function(condition) {
        return {
            type: constants.REQUEST_CONDITION
        };
    }

    var _receiveCondition = function(data) {
        return {
            type: constants.RECEIVE_CONDITION,
            data: data.condition,
            receivedAt: Date.now()
        };
    }

    var _fetchConditionError = function(error) {
        return {
            type: constants.REQUEST_CONDITION_ERROR,
            errors: error.data
        };
    }

    var _fetchCondition = function(condition) {
        return function(dispatch) {
            dispatch(_requestCondition());
            return api.get('/proxy/v1/conditions?friendlyUrl=' + condition)
                .then(function(data) {
                    dispatch(_receiveCondition(data));
                })
                .catch(function(error) {
                    if(error.response){
                        dispatch(_fetchConditionError(error.response));
                    }else{
                        dispatch(commonActions.setGenericError('', error.message));
                    }
                });
        };
    }

    var _shouldFetchCondition = function(state, friendlyUrl) {
        var selectedCondition = state.selectedCondition;
        if (Object.keys(selectedCondition).length === 0) {
            return true;
        } else if (!(selectedCondition.items && selectedCondition.items[0] && (selectedCondition.items[0].friendlyUrl === friendlyUrl))) {
            return true;
        } else {
            return false;
        }
    }

    var _fetchConditionIfNeeded = function(condition) {
        return function(dispatch, getState) {
            if (_shouldFetchCondition(getState(), condition)) {
                return dispatch(_fetchCondition(condition))
            }
        }
    }

    var _resetCondition = function(){
        return {
            type: constants.RESET_CONDITION
        }
    }

    var _setActiveIntervention = function(intervention) {
        return {
            type: constants.SET_ACTIVE_INTERVENTION,
            intervention: intervention
        };
    }

    var _resetActiveIntervention = function(){
        return {
            type: constants.RESET_ACTIVE_INTERVENTION
        };
    }

    var _fetchFeaturedPlacement = function(webTag) {
        return function(dispatch) {
            return api.get(webTag)
                .then(function(data) {
                    dispatch(_setFeaturedPlacement(data));
                })
                .catch(function(error){
                    if(error.response){
                        dispatch(commonActions.setGenericResponseError('', error.response));
                    }else{
                        dispatch(commonActions.setGenericError('', error.message));
                    }
                });
        };
    }

    var _setFeaturedPlacement = function(data) {
        return {
            type: constants.SET_FEATURED_PLACEMENT,
            featuredPlacement: data.placements.placement_1
        };
    }

    var _resetFeaturedPlacement = function(){
        return {
            type: constants.RESET_FEATURED_PLACEMENT
        };
    }

    var _fetchSponsoredPlacement = function(webTag, completeCallback) {
        return function(dispatch) {
            return api.get(webTag)
                .then(function(data) {
                    dispatch(_setSponsoredPlacement(data));
                    completeCallback && completeCallback();
                })
                .catch(function(error){
                    if(error.response){
                        dispatch(commonActions.setGenericResponseError('', error.response));
                    }else{
                        dispatch(commonActions.setGenericError('', error.message));
                    }
                    completeCallback && completeCallback();
                });
        };
    }

    var _setSponsoredPlacement = function(data) {
        return {
            type: constants.SET_SPONSORED_PLACEMENT,
            sponsoredPlacement: data.placements.placement_1
        };
    }

    var _resetSponsoredPlacement = function(){
        return {
            type: constants.RESET_SPONSORED_PLACEMENT
        };
    }

    return {
        fetchConditionIfNeeded: _fetchConditionIfNeeded,
        resetCondition: _resetCondition,
        setActiveIntervention: _setActiveIntervention,
        resetActiveIntervention: _resetActiveIntervention,
        fetchFeaturedPlacement: _fetchFeaturedPlacement,
        resetFeaturedPlacement: _resetFeaturedPlacement,
        fetchSponsoredPlacement: _fetchSponsoredPlacement,
        resetSponsoredPlacement: _resetSponsoredPlacement
    }
})();

module.exports = Condition;



// WEBPACK FOOTER //
// ./src/common/modules/conditions/actions/condition.js